import translationEn from "./en/translationEn.json";
import translationAr from "./ar/translationAr.json";
import * as Constants from "../constants/Constants.js";
// import * as Helpers from "../global/Helpers";

export function OverrideLocalEn() {
  let local = translationEn;
  switch (localStorage.getItem(Constants.localStorageConstants.company_name)) {
    case "IFS":
      local["orderid"] = "Order ID";
      local["closeprice"] = "Close price";
      local["marketvaluePortfolio"] = "Market value";
      local["mobileNo"] = "Mobile No (971xxxxxxxxxx)";
      local["breakevenPrice"] = "Break-even";
      local["UnUtilizedMarginAmount"] = "Utilized Margin Amount";
      local["InternalTransfer"] = "Within Your Accounts";
      local["ExternalTransfer"] = "Bank Transfer";
      break;
    case "UNITED":
      local["WelcomeMessage"] =
        "Welcome to UNITED SECURITIES Online Trading Portal";
      local["last"] = "Price";
      local["qty"] = "Shares";
      local["NAV"] = "Value";
      local["breakevenPrice"] = "Breakeven price";
      local["closeprice"] = "Close price";
      local["marketvaluePortfolio"] = "Market value";
      local["profitloss"] = "Profit/Loss";
      local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
      local["sendOtp"] = "Submit";
      local["TradingNumber"] = "MSM Number";
      local["IPO_Authintication"] = "Sell IPO shares";

      break;
    case "GLOBAL":
      local["WelcomeMessage"] =
        "Welcome to GLOBAL FINANCIAL SECURITIES  Online Trading Portal";
      local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
      local["last"] = "Price";
      local["qty"] = "Shares";
      local["NAV"] = "Value";
      local["breakevenPrice"] = "Breakeven price";
      local["closeprice"] = "Close price";
      local["marketvaluePortfolio"] = "Market value";
      local["profitloss"] = "Profit/Loss";
      local["sendOtp"] = "Submit";
      local["IPO_Authintication"] = "Sell IPO shares";
      break;
    case "ADCB":
      local["WelcomeMessage"] = "Sign in to start trading online";
      break;
    case "ALRAMZ":
      local["mobileNo"] = "Mobile No (971xxxxxxxxxx)";
      break;
    case "CIBC":
      local["WelcomeMessage"] = "Welcome to Mahfazty";
      local["sendOtp"] = "Submit";
      local["otp"] = "Enter Your Second Authentication.";
      local["otpDesc"] = "second password";
      local["validity"] = "Execution Type";
      break;
    case "FSC":
      local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
      local["sendOtp"] = "Verify";
      local["IPO_Authintication"] = "Sell IPO shares";
      break;
    case "UBHAR":
      local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
      local["sendOtp"] = "Submit";
      local["IPO_Authintication"] = "Sell IPO shares";
      break;
    case "HORIZON":
      local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
      local["sendOtp"] = "Submit";
      local["IPO_Authintication"] = "Sell IPO shares";

      break;
    case "AHLI":
      local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
      local["sendOtp"] = "Submit";
      local["IPO_Authintication"] = "Sell IPO shares";

      break;
    case "Vision":
      local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
      local["sendOtp"] = "Submit";
      local["IPO_Authintication"] = "Sell IPO shares";

      break;
    case "SIFS":
      local["ForgotPassword"] = "Reset password";
      local["PreferredLanguage"] = "Communication language";
      local["sendOtp"] = "Submit";
      local["otp"] = "Enter the OTP Sent on your registered number :";
      local["cancelOrderMsg"] =
        "Are You sure you want to cancel this request? ";
      local["symbol_is_required"] = "Please select Stock";
      local["Price_must_be_between_min"] =
        "Request Price must be between Minimum and Maximum limit ";
      local["userLocked"] =
        "User suspended for exceeding the allowed number of log in attempts. Please contact 0097165992555 ";
      break;
    case "PIONEERS":
      local["WelcomeMessage"] = "Pioneers Securities E-Trade";
      local["sendOtp"] = "Submit";
      local["otp"] = "Enter Your Second Authentication.";
      local["otpDesc"] = "second password";
      // local["bankName"] = "Deposit Bank";
      local["bankAccountNo"] = "Account Number/IBAN";
      // local["branch"] = "Country/Branch";
      local["Please_enter_OTP"] = "Please enter second password";
      local["invalidOTP"] = "invalid second password";
      local["closeprice"] = "Close price";
      local["profitloss"] = "Profit/Loss";
      local["AsMkt"] = "Mkt %";
      break;
    case "QSC":
      local["WelcomeMessage"] = "Welcome to QSC online trading platform";
      local["closeprice"] = "Last Price";
      break;
    case "BHM":
      local["WelcomeMessage"] = "Welcome to BHM online trading platform";

      break;
  }
  return local;
}

export function OverrideLocalAr() {
  let local = translationAr;
  switch (localStorage.getItem(Constants.localStorageConstants.company_name)) {
    case "IFS":
      local["orderid"] = "رقم الطلب";
      local["mobileNo"] = "رقم الموبايل (971xxxxxxxxxx)";
      local["InternalTransfer"] = "ضمن حساباتك";
      local["ExternalTransfer"] = "تحويل بنكي";
      break;
    case "UNITED":
      local["WelcomeMessage"] =
        "مرحباً بكم في موقع التداول الإلكتروني لشركة المتحدة للأوراق المالية";
      local["last"] = "السعر";
      local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";
      local["IPO_Authintication"] = "بيع اسهم االاكتتاب";

      break;
    case "GLOBAL":
      local["WelcomeMessage"] =
        "مرحباً بكم في موقع التداول الإلكتروني لشركة الدولية للأوراق المالية";
      local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";
      local["IPO_Authintication"] = "بيع اسهم االاكتتاب";
      break;
    case "ADCB":
      local["WelcomeMessage"] = "قم بتسجيل الدخول لبدء التداول عبر الإنترنت";
      break;
    case "ALRAMZ":
      local["mobileNo"] = "رقم الموبايل (971xxxxxxxxxx)";
      break;
    case "CIBC":
      local["WelcomeMessage"] = "مرحبا بك في محفظتي";
      local["otp"] = "كلمة المرور الثانية";
      break;
    case "FSC":
      local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";
      local["IPO_Authintication"] = "بيع اسهم االاكتتاب";
      break;
    case "UBHAR":
      local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";
      local["IPO_Authintication"] = "بيع اسهم االاكتتاب";
      break;
    case "HORIZON":
      local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";
      local["IPO_Authintication"] = "بيع اسهم االاكتتاب";
      break;
    case "AHLI":
      local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";
      local["IPO_Authintication"] = "بيع اسهم االاكتتاب";
      break;
    case "Vision":
      local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";
      local["IPO_Authintication"] = "بيع اسهم االاكتتاب";
      break;
    case "SIFS":
      local["ForgotPassword"] = "تعيين كلمة المرور";
      local["otp"] = "أدخل الرمز المؤقت OTP المرسل إلى رقم هاتفك المسجل";
      local["DepositTitle"] = "إيداع";
      local["userLocked"] =
        "تم إيقاف المستخدم لتجاوز عدد محاولات تسجيل الدخول المسموح بها. الرجاء التواصل على 0097165992555";
      break;
    case "PIONEERS":
      local["otp"] = "كلمة المرور الثانية";
      // local["bankName"] = "البنك المحول اليه";
      local["bankAccountNo"] = "رقم الحساب / IBAN المحول اليه";
      // local["branch"] = "الدولة/الفرع";
      local["Please_enter_OTP"] = "يجب ادخال كلمة المرور الثانية";
      local["invalidOTP"] = "كلمة المرور الثانية غير صحيحة";
      local["AsMkt"] = "النسبة السوقية";
      break;
     case "QSC":
      local["WelcomeMessage"] = "اهلا و سهلا في نظام التداول الالكتروني";
      break;
     case "BHM":
      local["WelcomeMessage"] = "اهلا و سهلا في نظام التداول الالكتروني";
      break;
  }
  return local;
}
